<template>
  <div class="header-gradient">
    <v-layout pa-2 align-center column fill-height class="lightbox white--text">
      <v-container>
        <h1>{{title}}</h1>
        <slot/>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: null
  }
};
</script>

<style lang="stylus">
@import '~vuetify/src/stylus/main';

.custom-selector {
  font-size: 3em;

  @media $display-breakpoints.xs-only {
    font-size: 2em;
  }

  @media $display-breakpoints.lg-and-up {
    font-size: 5em;
  }
}
</style>